import { OnInit } from '@angular/core';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
var TablePanelComponent = /** @class */ (function () {
    function TablePanelComponent() {
    }
    Object.defineProperty(TablePanelComponent.prototype, "hostClasses", {
        get: function () { return resolveThemeCssClass(this.data.panelSettings); },
        enumerable: true,
        configurable: true
    });
    TablePanelComponent.prototype.ngOnInit = function () {
        this.checkFirstRowAsHeader();
    };
    TablePanelComponent.prototype.checkFirstRowAsHeader = function () {
        if (this.data.table.value.useFirstRowAsHeader) {
            this.headerRow = this.data.table.value.cells[0];
            this.data.table.value.cells.shift();
        }
    };
    TablePanelComponent.prototype.getAlignClass = function (cell) {
        switch (cell.align) {
            case 'cell-left': return 'left';
            case 'cell-right': return 'right';
            case 'cell-center': return 'center';
            default: return '';
        }
    };
    return TablePanelComponent;
}());
export { TablePanelComponent };
